import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

/**
 * MUI Components
 */
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';

/**
 * MUI Icons
 */
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import GroupsIcon from '@mui/icons-material/Groups';

const StaffSelectControl = ({ value, list, handleChange, responsableSID, includeDummy = true }) => {
    const { t } = useTranslation();
    const [localValue, setLocalValue] = useState(value);

    const addIcon = (sid) => {
        if (responsableSID == sid) {
            return (
                <ListItemIcon>
                    <EmojiPeopleIcon fontSize="small" />
                </ListItemIcon>
            );
        }
    };

    // Only set localValue from value on the first render
    useEffect(() => {
        setLocalValue(value);
        handleChange({ target: { name: 'selectStaff', value } });
        // console.debug('StaffSelectControl local:', localValue, 'initial:', value, 'responsible:', responsableSID);
    }, [value]);

    const handleLocalChange = (event) => {
        const newValue = event.target.value;
        setLocalValue(newValue);
        handleChange(event);
    };

    return (
        <FormControl fullWidth>
            <InputLabel id="select-staff-label">{t('Worker')}</InputLabel>
            <Select
                labelId="select-staff-label"
                id="select-staff"
                name="selectStaff"
                value={localValue}
                onChange={handleLocalChange}
                label={t('Worker')}
                required
            >
                {includeDummy && (
                    <MenuItem value={0}>
                        <ListItemIcon>
                            <GroupsIcon fontSize="small" />
                        </ListItemIcon>
                        {t('Assign to work group')}
                    </MenuItem>
                )}
                {list.map((employee) => (
                    <MenuItem key={employee.id} value={employee.id}>
                        {addIcon(employee.id)}
                        {employee.full_name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

StaffSelectControl.propTypes = {
    value: PropTypes.number,
    list: PropTypes.array.isRequired,
    handleChange: PropTypes.func.isRequired,
    responsableSID: PropTypes.number,
    includeDummy: PropTypes.bool,
};

export default StaffSelectControl;
